import { AssetActivityControlRequest, AuthModel } from "@gtpl/shared-models/common-models";
import { Body, Controller, Inject, Logger, Post } from "@nestjs/common";
import { AssentManagementJobService } from "./asset-mgmt.service";
import { Request } from 'express';
import { REQUEST } from '@nestjs/core';
import { ApiBearerAuth } from "@nestjs/swagger";

@ApiBearerAuth()
@Controller('assent-mgnt-jobs')
export class AssetManagementController {
    constructor(
        private authModel: AuthModel,
        private service: AssentManagementJobService,
        @Inject(REQUEST) private request: Request,
    ) {
        this.authModel.authorization = this.request.headers.authorization.toString();
    }
}